export default {
  set_error(state, value) {
    state.errors=[value]
  },
  reset_error(state) {
    state.errors=[]
  },
  set_loading(state) {
    state.loading = true;
  },
  unset_loading(state) {
    state.loading = false;
  },
};
